import React, { useMemo, useState } from 'react';
import { SEAT_TOKEN_KEY, signOutSeat } from '@/api/seat';
import { purgeSeatBackups } from '@/state/seatSession';
import { TakeHomePlayer } from './TakeHomePage';
import { useNoReferrer } from './useNoReferrer';

export function HomeSeatPage({ session, token, onExit }) {
  useNoReferrer();
  const [signingOut, setSigningOut] = useState(false);
  const wipeDate = useMemo(() => {
    const value = new Date(session.wipe_at);
    return Number.isNaN(value.getTime()) ? '' : value.toLocaleDateString(undefined, {
      month: 'long', day: 'numeric', year: 'numeric',
    });
  }, [session.wipe_at]);

  const signOut = async () => {
    if (signingOut) return;
    setSigningOut(true);
    try { await signOutSeat(token); } catch { /* Local sign-out still protects a shared device. */ }
    sessionStorage.removeItem(SEAT_TOKEN_KEY);
    purgeSeatBackups();
    onExit('');
  };

  return <main className="seat-home" data-skin="playground" data-testid="seat-home-view">
    <header className="seat-home-header">
      <div className="public-takehome-brand"><img src="/Pizzul_Hero.png" alt="" /><span>LET THE BEAT BUILD</span></div>
      <button onClick={signOut} disabled={signingOut}>Sign out</button>
    </header>
    <section className="seat-home-intro">
      <p>{session.program.name} <span aria-hidden="true">·</span> Seat {session.seat_number}</p>
      <h1>Your beats</h1>
      {wipeDate && <p>Download before {wipeDate}</p>}
    </section>
    <div className="seat-home-beats">
      {session.takehomes.map((takehome) => <TakeHomePlayer key={takehome.slot} data={takehome} programName={session.program.name} expiry={wipeDate} />)}
      {!session.takehomes.length && <section className="seat-home-missing">
        <h2>No beats saved for home</h2>
        <p>Ask your teacher when your next class starts.</p>
      </section>}
    </div>
  </main>;
}

export default HomeSeatPage;
